/** @file A base entry's share of its track's result: its cover times its own fade-in (R19-02 follow-up). */
import type { AnimState, TrackEntry } from '../../contracts/state';
import { mixWeight } from '../mixWeight';
import { ownerCover } from './ownerCover';

/**
 * ownerCover × the owner's own weight: mixWeight(owner) while it mixes from an entry, or while it fades in with
 * nothing to mix from on tracks 1+ (§5.7 m3); 1 for the bottom link of track 0 (R19-01: it shows at once). So a fix
 * layer fades in with a base crossfade into its directional entry and out with the crossfade away from it.
 */
export function ownerShare(state: AnimState, track: number, owner: TrackEntry): number {
  const cover = ownerCover(state, track, owner);
  if (cover === 0) return 0;
  return owner.from !== null || track > 0 ? cover * mixWeight(owner) : cover;
}
